module.exports = __webpack_public_path__ + "static/media/close-arrow.69893d90.svg";